var React = require('react');

function ArrowRightInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M20 12H2m12 8.005l8-8-8-8","fill":"none","strokeLinecap":"square","strokeLinejoin":"round","stroke":"currentColor","strokeWidth":"2"}));
}

ArrowRightInline.defaultProps = {"viewBox":"0 0 24 24"};

module.exports = ArrowRightInline;

ArrowRightInline.default = ArrowRightInline;
